import { Card, H1, Row, useContainerWidth, Breadcrumbs, MarginBox } from '@fs/zion-ui'
import React from 'react'
import { PlaceEditorNavMenu } from './PlaceEditorTrainingNav'

export default function PlaceEditorTrainingHeader() {
  const atWidth = useContainerWidth()
  const isMobile = atWidth({ default: true, lg: false })

  const breadcrumbs = [
    { text: 'Editor Handbook', to: '/editor-handbook/' },
    { text: 'Editor Training', to: '/editor-handbook/training/' },
  ]

  return (
    <Card margins="dense">
      <MarginBox marginX="nano" marginY="nano">
        <Row wrap alignItemsY="middle">
          <H1 size="H3" growX>
            FS Place Editors Training
          </H1>
          {isMobile ? <PlaceEditorNavMenu /> : null}
        </Row>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </MarginBox>
    </Card>
  )
}
